module.exports = __webpack_public_path__ + "assets/4e375bcb2b6e7ef1619337c86320184a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channels/hu/5.png
// module id = 343
// module chunks = 1